import React, { useEffect } from "react";
import Header from "./Header";
import cover from "./res/cover1000px.jpg";
import About from "./homePageComp/About";
import Publisher from "./homePageComp/Publisher";
import Editorial from "./homePageComp/Editorial";
import Footer from "./homePageComp/Footer";

function JournalHome(props) {
  useEffect(() => {
    document.title =
      "Asian Journal of Research in Science and Technology - AJORIST";
  }, []);
  return (
    <React.Fragment>
      <Header />
      {/* Hero Section */}
      <section className="flex flex-col lg:flex-row bg-sky-900">
        <div className="flex-1 lg:order-2">
          <img
            className="w-full h-64 lg:h-full object-cover"
            src={cover}
            alt="Academic journal cover with abstract design"
          />
        </div>
        <div className="flex-1 lg:order-1 text-white flex flex-col justify-center p-8 md:p-12 lg:p-16">
          <div className="max-w-xl">
            <h1 className="text-3xl md:text-4xl font-bold text-sky-100 leading-tight">
              Call for Papers: 2026 Edition
            </h1>
            <p className="mt-4 text-base md:text-lg text-sky-200 font-light">
              We are pleased to announce the Call for Research Papers for the
              year 2023 in the
              <strong className="font-semibold text-white">
                Asian Journal of Research in Science and Technology (AJORIST)
              </strong>
              . As an esteemed online research journal, we invite researchers,
              scientists, and professionals to submit original papers fostering
              scientific advancements and technological innovations.
            </p>
          </div>
          <div className="mt-8">
            <a
              className="inline-block bg-sky-500 text-white font-semibold py-3 px-8 rounded-lg shadow-md hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-opacity-75 transition-all"
              href="/journal"
            >
              Learn More & Submit
            </a>
          </div>
        </div>
      </section>
      <About />
      <Publisher />
      <Editorial />
      <Footer />
    </React.Fragment>
  );
}

export default JournalHome;
